import React, { forwardRef } from 'react';
import { Modal, Form, Input, Button } from 'antd';

export default forwardRef((props, ref) => {
  const [form] = Form.useForm();
  const onFinish = (values) => {
    props.getFormValues(values);
  };
  return (
    <Modal title='取消订单' open footer={null} onCancel={()=>props?.cancelOrder?.()}>
      <Form name="basic" labelCol={{ span: 8, }} wrapperCol={{ span: 16, }} form={form} onFinish={onFinish}>
        <Form.Item label="取消原因" name="cancel_desc"><Input placeholder='请填写取消原因' /></Form.Item>
        <Form.Item {...{ wrapperCol: { offset: 8, span: 16, } }} style={{ marginTop: 60 }}>
          <Button htmlType="button" onClick={() => props?.cancelOrder?.()}>取消</Button>
          <Button type="primary" htmlType="submit" style={{ marginLeft: 80 }}>确认</Button>
        </Form.Item>
      </Form>
    </Modal >
  );
});
